module.exports = __webpack_public_path__ + "static/img/book_2.fa23ae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/book_2.png
// module id = ol7K
// module chunks = 1